module.exports = __webpack_public_path__ + "static/media/overall-feelings.455de402.svg";